import { useMemo, useState } from 'react';
import { FeatureSet } from '~shared/types/pricing/features';
import { FeatureSetMap } from '~pricing/transformers/types';
import { convertFeatureSetToMap } from '~pricing/lib/lib-helpers';

/**
 * Given an array of features, return a Map with [key: string] and Feature
 * @param {FeatureSet}  featureSet  An array of features
 * @returns {FeatureSetMap} A map of features
 */
export default function usePackageFeatureSet(featureSet: FeatureSet): FeatureSetMap {
  const [featureSetMap, setFeatureSetMap] = useState<FeatureSetMap>({});
  useMemo(() => {
    setFeatureSetMap(convertFeatureSetToMap(featureSet));
  }, [featureSet]);

  return featureSetMap;
}
